const getPhaseTabIndex = (phaseTab: string) => {
    switch (phaseTab) {
        case 'Phase 1': return 0
        case 'Phase 2': return 1
        case 'Phase 3': return 2
        default:        return 0
    }
}

export default getPhaseTabIndex